export const salesReportCopy = {
  stockColumn: 'Saldo',
  stockSummary: (remaining: string, capacity: string): string => `${remaining} de saldo · capacidade ${capacity}`,
  stockSummaryCompact: (tickets: string, remaining: string, capacity: string): string =>
    `${tickets} ingressos · ${remaining} de saldo · cap. ${capacity}`,
  issuedShare: (percent: string): string => `${percent} da capacidade emitida`,
  revenueShare: (percent: string): string => `${percent} da receita total`,
  ticketsPill: (count: string): string => `${count} ingressos`,
  packageStockTitle: 'Capacidade controlada pelo evento-pacote',
  unlimited: 'Sem limite',
  exhausted: 'Esgotado',
  stockNote: 'O saldo considera ingressos emitidos. Reservas em andamento podem reduzir a disponibilidade para compra.',
  capacityAlert: (items: string): string => `Capacidade esgotada: ${items}.`,
  exceededSuffix: ' (excedida)',
  seatMapSeats: 'Lugares no mapa do Seats.io',
  seatMapFree: 'Lugares livres no mapa do Seats.io agora',
  seatMapHeld: 'Lugares reservados pelo painel no mapa do Seats.io agora',
  seatMapShared: 'A categoria do mapa é compartilhada com outro setor, então não dá para separar os lugares',
  seatMapUnavailable: 'Mapa do Seats.io indisponível no momento',
  unlimitedInTotal: 'Há grupo sem limite de capacidade',
  partialGroup: 'Parte das linhas deste grupo ficou fora do limite da tela. Exporte o XLSX para ver tudo.',
  commissionerOnly: 'Somente vendas de comissários. Vendas sem comissário ficam fora deste agrupamento.',
  commissionerPaymentTitle: 'Vendas dos comissários por forma de pagamento',
}
